import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Education from '../components/Education';
import Publications from '../components/Publications';
import Organizations from '../components/Organizations';
import Contact from '../components/Contact';
import AnimatedBackground from '../components/AnimatedBackground';
import DownloadResumeButton from '../components/DownloadResumeButton';

const Portfolio = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen">
      <AnimatedBackground />
      <Navigation scrolled={scrolled} />
      <main className="relative z-10">
        <Hero />
        <About />
        <Experience />
        <Skills />
        <Education />
        <Publications />
        <Organizations />
        <Contact />
      </main>
      <DownloadResumeButton />
    </div>
  );
};

export default Portfolio;